/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../../shared/response-with-error-generic';
import { GetAllErpArticlesResponseJson } from './get-all-erp-articles-response-json';
import { DefaultGetResult } from '../../results/default-get-result.enum';
import { IResponseWithErrorGeneric } from '../../shared/iresponse-with-error-generic.interface';
import { ErpArticleDto } from '../models/erp-article-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetAllErpArticlesResponse extends ResponseWithErrorGeneric<GetAllErpArticlesResponseJson, DefaultGetResult> implements IResponseWithErrorGeneric<DefaultGetResult> {
  public erpArticles: ErpArticleDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetAllErpArticlesResponse>) {
    super(response, DefaultGetResult.Error);
    if (this.result !== DefaultGetResult.Success) {
      return;
    }

    this.erpArticles = this.body.erpArticles;
  }
  //</custom-body>
}
